module.exports = __webpack_public_path__ + "static/img/funny_23.26ecc471.jpg";